<template>
  <v-app>
    <SidebaeAdmin
      :notification-count="notiTotal"
      @logout="handleLogout"
      @open-notification="notiPanel = true"
    />

    <!-- แผงการแจ้งเตือน: สรุปงานค้างที่ต้องดำเนินการ -->
    <v-navigation-drawer
      v-model="notiPanel"
      app
      right
      temporary
      width="360"
      class="noti-drawer"
    >
      <div class="noti-header">
        <div class="noti-header-title">
          <v-icon color="#F4811F" class="mr-2">mdi-bell-outline</v-icon>
          <span>การแจ้งเตือน</span>
          <v-chip
            v-if="notiTotal > 0"
            small
            color="#FDECEC"
            text-color="#EE2526"
            class="ml-2 font-weight-bold"
          >
            {{ notiTotal }}
          </v-chip>
        </div>
        <v-btn icon @click="notiPanel = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider />

      <div v-if="notiLoading" class="noti-state">
        <v-progress-circular indeterminate color="#F4811F" size="28" />
      </div>

      <div v-else-if="notiItems.length === 0" class="noti-state">
        <v-icon size="48" color="#cbd5e1">mdi-check-circle-outline</v-icon>
        <p class="noti-empty-text">ไม่มีงานค้างที่ต้องดำเนินการ</p>
      </div>

      <v-list v-else two-line class="py-0">
        <v-list-item
          v-for="item in notiItems"
          :key="item.key"
          class="noti-item"
          @click="goTo(item)"
        >
          <v-list-item-avatar class="noti-item-avatar">
            <v-icon color="#F4811F">{{ item.icon }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="noti-item-title">
              {{ item.title }}
            </v-list-item-title>
            <v-list-item-subtitle class="noti-item-sub">
              รอดำเนินการ {{ item.count }} รายการ
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-chip small color="#FEF3ED" text-color="#F4811F" class="font-weight-bold">
              {{ item.count }}
            </v-chip>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="noti-footer">
          <v-btn
            text
            block
            color="#F4811F"
            :loading="notiLoading"
            @click="loadNotifications"
          >
            <v-icon left small>mdi-refresh</v-icon>
            รีเฟรช
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import SidebaeAdmin from "@/components/SidebarAdmin.vue";
import { logoutApi } from "@/services/api/auth";
import { getAdminNotificationsApi } from "@/services/api/adminServices";

const POLL_INTERVAL = 60000; // 60 วินาที

export default {
  name: "DefaultAdmin",
  components: {
    SidebaeAdmin,
  },

  data() {
    return {
      notiPanel: false,
      notiLoading: false,
      notiTotal: 0,
      notiItems: [],
      pollTimer: null,
    };
  },

  created() {
    this.loadNotifications();
    this.pollTimer = setInterval(this.loadNotifications, POLL_INTERVAL);
  },

  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  },

  methods: {
    async loadNotifications() {
      this.notiLoading = true;
      try {
        const data = await getAdminNotificationsApi();
        this.notiItems = data.items || [];
        this.notiTotal = data.total || 0;
      } catch (e) {
        console.error("[DefaultAdmin] load notifications failed:", e);
      } finally {
        this.notiLoading = false;
      }
    },

    goTo(item) {
      this.notiPanel = false;
      if (item.to && this.$route.path !== item.to) {
        this.$router.push(item.to).catch(() => {});
      }
    },

    async handleLogout() {
      try {
        await logoutApi().catch(() => {});
      } catch (e) {
        console.error("Logout error:", e);
      } finally {
        if (this.$store && this.$store.dispatch) {
          await this.$store
            .dispatch("logout", { authGroup: "admin" })
            .catch(() => {});
        }

        sessionStorage.clear();

        this.$router.replace({ name: "login_admin" }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
:deep(main.v-main) {
  min-height: 100vh;
  background: #f6f9ff;
}

.noti-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 12px 14px 16px;
}
.noti-header-title {
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: 700;
  color: #1f2a39;
}
.noti-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 16px;
  text-align: center;
}
.noti-empty-text {
  color: #6b717f;
  font-size: 14px;
  margin: 0;
}
.noti-item {
  cursor: pointer;
  transition: 0.2s background;
}
.noti-item:hover {
  background: #fef7f1;
}
.noti-item-avatar {
  background: #fef3ed;
}
.noti-item-title {
  font-size: 14px !important;
  font-weight: 600;
  color: #1f2a39;
}
.noti-item-sub {
  font-size: 12px !important;
  color: #6b717f;
}
.noti-footer {
  padding: 6px 8px 10px;
  border-top: 1px solid #eef1f5;
}
</style>
